import app from './app';
import {StringArray} from '../@interfaces/types';

export function getRouteUri(routeName: string | { route: string, params?: string[] | StringArray<string> }, defaultValue?: string): string {
	const route = typeof routeName === 'string' ? {route: routeName, params: undefined} : routeName;

	return app('url').route(route.route, route.params) ?? defaultValue ?? '';
}
